import React, { useState, useEffect } from "react";
import Singleproductdetails from "../Components/Productdetails/Singleproductdetails";
import Breadcrumb from "../Components/Breadcrumb";
import Relatedproducts from "../Components/Productdetails/Relatedproducts";
import Reviewsandcomments from "../Components/Productdetails/Reviewsandcomments";
import SpecialProducts from "../Components/Productdetails/SpecialProducts";
import Customer from "../Components/Homepage/Customer";
import Writeacomment from "../Components/Productdetails/Writeacomment";
import Productsspecification from "../Components/Productdetails/Productsspecification";
import ProductSpecificationAccordion from "../Components/Productdetails/ProductSpecificationAccordion";
import axios from "axios";
import { useParams } from "react-router-dom";
import { apiurl } from "../Constants";
import AOS from "aos";
import "aos/dist/aos.css";
import { FadeLoader } from "react-spinners";
import SpecialproductsSingle from "../Components/Productdetails/SpecialproductsSingle";
function Productdetails() {
  const [productDetails, setProductDetails] = useState({});
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [categoryname, setCategoryname] = useState("");
  const [subcategoryname, setSubcategoryname] = useState("");
  const [subchildcategoryname, setSubchilcCategoryname] = useState("");
  const [productname, setProductname] = useState("");
  const [loading, setLoading] = useState(true);
  const { slug } = useParams();

  const [categorySlug, setCategorySlug] = useState("");
  const [subcategorySlug, setSubcategorySlug] = useState("");
  const [subchildSlug, setSubchildSlug] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [slug]);

  useEffect(() => {
    const fetchDatta = async () => {
      setLoading(true);
      await axios
        .post(apiurl + "product_detail", {
          product_slug: slug,
        })
        .then((res) => {
          const data = res.data.data;
          setProductDetails(data);
          setRelatedProducts(data.related_products);
          setCategoryname(data.category[0]?.category_name || "");
          setSubcategoryname(data.subcategory[0]?.subcategory_name || "");
          setSubchilcCategoryname(
            data.subchildcategory && data.subchildcategory[0]
              ? data.subchildcategory[0].subchildcategoryname
              : ""
          );
          setCategorySlug(data.category?.[0]?.slug || "");
          setSubcategorySlug(data.subcategory?.[0]?.slug || "");
          setSubchildSlug(data.subchildcategory?.[0]?.slug || "");
          setProductname(data.product_name || "");
          setLoading(false);
        });
    };
    fetchDatta();
  }, [slug]);

  useEffect(() => {
    AOS.init({
      once: false,
    });

    const handleScroll = () => {
      AOS.refresh();
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {loading ? (
        <div className="row">
          <div
            className="col-12"
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            {/* <FadeLoader /> */}
            <div class="dot-spinner">
              <div class="dot-spinner__dot"></div>
              <div class="dot-spinner__dot"></div>
              <div class="dot-spinner__dot"></div>
              <div class="dot-spinner__dot"></div>
              <div class="dot-spinner__dot"></div>
              <div class="dot-spinner__dot"></div>
              <div class="dot-spinner__dot"></div>
              <div class="dot-spinner__dot"></div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <Breadcrumb
            title_1="Home"
            title_2={categoryname}
            title_3={subcategoryname}
            title_4={subchildcategoryname}
            title_5={productname}
            categorySlug={categorySlug}
            subcategorySlug={subcategorySlug}
            subchildSlug={subchildSlug}
          />
          <Singleproductdetails
            productDetails={productDetails}
            overall_ratting={productDetails.overall_ratting}
            relatedProducts={relatedProducts}
          />
          {relatedProducts?.length > 0 ? (
            <Relatedproducts relatedProducts={relatedProducts} />
          ) : null}
          <Productsspecification productDetails={productDetails} />
          {/* <ProductSpecificationAccordion
            productDetails={productDetails}
            RelatedProducts={relatedProducts}
          /> */}
          {productDetails.product_type === 2 ? (
            <>
              <SpecialproductsSingle productDetails={productDetails} />
            </>
          ) : null}

          <Reviewsandcomments
            productDetails={productDetails}
            overall_ratting={productDetails.overall_ratting}
          />
          <Writeacomment product_id={slug} />
          {/* {relatedProducts?.length > 0 ? (
            <Relatedproducts relatedProducts={relatedProducts} />
          ) : null} */}
          <SpecialProducts />
          <Customer />
        </>
      )}
    </>
  );
}

export default Productdetails;
